export type CommerceTransportErrorCode =
    "operation-unsupported" | "request-cancelled" | "request-failed" | "response-invalid";

export interface CommerceTransportErrorOptions {
    readonly operationName: string;
    readonly cause?: unknown;
}

/** Stable transport failure surfaced without leaking an implementation-specific error shape. */
export class CommerceTransportError extends Error {
    public readonly code: CommerceTransportErrorCode;
    public readonly operationName: string;

    public constructor(
        code: CommerceTransportErrorCode,
        message: string,
        options: CommerceTransportErrorOptions,
    ) {
        super(message, options.cause === undefined ? undefined : { cause: options.cause });
        this.name = "CommerceTransportError";
        this.code = code;
        this.operationName = options.operationName;
    }
}
